import { findMany } from '../helpers';
import Dropdown from './dropdown-core';

const Menu = () => {
    findMany('.js-mega-menu').map(el => new Dropdown(el));

    return null;
}

Menu();
